<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <gg-toolbar @close="close">
        Manage SSH key
      </gg-toolbar>
      <v-card-text>
        <p>
          The key with the name “{{ sshKey.name }}” is currently “<strong>{{ sshKey.authstatus }}</strong>” for use
          when connecting to this account.
        </p>
      </v-card-text>
      <v-card-actions class="justify-content-end">
        <gg-btn
          class="mb-0"
          secondary
          @click="close"
        >
          Cancel
        </gg-btn>
        <gg-btn
          :loading="loading"
          class="mb-0"
          @click="manage"
        >
          {{ buttonText }}
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ManageSshKeyModal',
  mixins: [modalMixin],
  props: {
    sshKey: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    buttonText () {
      return this.sshKey.authstatus == 'authorized' ? 'Deauthorize' : 'Authorize'
    }
  },
  methods: {
    ...mapActions(['authHostingSshKey', 'reportSuccess', 'reportError']),
    async manage () {
      this.loading = true
      const data = {
        key: this.sshKey.key,
        action: this.sshKey.authaction,
        _username: this.$route.query.user,
      }
      try {
        const response = await this.authHostingSshKey(data)
        this.reportSuccess(`The key “${this.sshKey.name}” has been ${response[0].status}.`)
        this.$emit('ssh-key-updated')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
        this.close()
      }
    },
  }
}
</script>
